<template>
    <h2>
        {{ $t("Distributor.AuthorizedLineCardHeading") }}
        <span class="text-muted text-base font-normal">{{ distributor.RegionName }}</span>
    </h2>

    <p>
        {{ $t("Distributor.AuthorizedLineCardParagraph", [distributor?.Name]) }}
    </p>

    <div class="sticky top-20 hidden md:flex bg-white" data-test-id="distributor-manufacturer-letter-nav">
        <a
            v-for="(group, key) in groupings"
            :key="key"
            :href="`#${key}`"
            class="block text-center w-12 h-12 leading-12 text-sm font-bold mb-1 hover:bg-accent hover:text-white transition-bg">
            {{ key }}
        </a>
    </div>

    <div class="divide-y divide-gray-100">
        <div v-for="(group, key) in groupings" :key="key" class="mb-4">
            <h3 :id="`${key}`" class="my-4 md:scroll-pt-[130px] md:scroll-mt-[130px]">
                {{ key }} ({{ group.length }})
            </h3>
            <ul class="list-style-none columns-2xs">
                <li v-for="mfr in group" :key="mfr.VirtualPath" class="mb-1">
                    <NuxtLinkLocale
                        v-if="mfr.ActiveLink"
                        :to="'/manufacturers/' + mfr.VirtualPath"
                        :title="mfr.DisplayName"
                        class="block pb-1">
                        {{ mfr.DisplayName }}
                    </NuxtLinkLocale>
                    <div v-else class="block pb-1">{{ mfr.DisplayName }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup lang="ts">
const { distributor } = injectDistributor();

const groupings = computed<Record<string, RegionManufacturers[]>>(() => {
    const regionManufacturers = distributor.value?.RegionManufacturers;
    const groups: Record<string, RegionManufacturers[]> = {};

    if (regionManufacturers) {
        regionManufacturers.forEach((regionManufacturer: RegionManufacturers) => {
            const name = regionManufacturer.DisplayName;
            const firstChar: string = name.charAt(0).toUpperCase();
            const key = /\d/.test(firstChar) ? "#" : firstChar;

            if (!groups[key]) {
                groups[key] = [];
            }

            groups[key].push(regionManufacturer);
        });

        Object.keys(groups).forEach((key) => {
            groups[key]?.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
        });

        return (Object.keys(groups) as Array<keyof typeof groups>)
            .sort()
            .reduce((obj: Record<string, RegionManufacturers[]>, key: string) => {
                obj[key] = groups[key] ?? [];
                return obj;
            }, {});
    }

    return {};
});
</script>
